var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAhFooterLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.3 67.6",
    style: {
      enableBackground: "new 0 0 107.3 67.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0B61D;}\n\t.st1{fill:#71C058;}\n\t.st2{fill:#1AAB4F;}\n\t.st3{fill:#E6E7E8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,30.9c0.2-0.1,0.4-0.1,0.6-0.2c1.3-2.6,2.1-5.5,2.1-8.6C72.3,11.6,63.8,3,53.2,3c-6.9,0-13,3.7-16.3,9.2 C49.5,15.4,60.8,22,69.7,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.9,12.2C31.3,10.8,25.5,10,19.5,10c-5,0-9.9,0.5-14.6,1.5c-0.1,1-0.1,1.9-0.1,2.9v0 c0,18.7,10.3,35,25.5,43.6c4.9-6.9,11-12.8,18-17.5c6.4-4.3,13.6-7.6,21.4-9.7C60.8,22,49.5,15.4,36.9,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.9,28.5c-6.1,0-12,0.8-17.6,2.2c-0.2,0-0.4,0.1-0.6,0.2c-7.7,2-14.9,5.3-21.4,9.7c-7,4.7-13.1,10.7-18,17.5 c7.3,4.1,15.7,6.5,24.6,6.5h0c11.4,0,21.9-3.8,30.3-10.2c8-6.1,14.1-14.5,17.3-24.3C97.8,29.1,92.9,28.5,87.9,28.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.8,14.4h-0.9V17h-0.8v-2.6h-0.9v-0.7h2.5V14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.4,17h-0.8V15l-0.9,1.4h-0.1L76.8,15V17h-0.8v-3.3h0.8l0.9,1.5l0.9-1.5h0.8V17z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhFooterLogo01);
export default __webpack_public_path__ + "static/media/AH_Footer_logo-01.094a7c374033725a12cb4f92f1b00f0d.svg";
export { ForwardRef as ReactComponent };